// extracted by mini-css-extract-plugin
module.exports = {"RoleItem":"_2PFVQxzF0_N1aiUXlB5R6E","RoleItemActive":"_33s1n3zouE3JjvimSWY2Aa","RoleItemTitle":"J6sygxHZKtGe41ynQPmbK","RoleItemSubTitle":"_2B2VMT-yJqswQCD2CeqeaS"};